/* eslint-disable import/prefer-default-export */

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  /* root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    }, */
  contentSearch: {
    marginTop: 7,
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 20,
  },
  formControl: {
    margin: theme.spacing(1),
    width: '15.2%',
    minWidth: '15.2%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  formControlSearch: {
    marginTop: 20,
  },
}));
